import type { CanvasLoadState, CanvasModeConfiguration } from "../domain/types";
import { useCanvasMessages } from "./i18n";

export interface CanvasStatusOverlayProps {
  loadState: CanvasLoadState;
  mode: CanvasModeConfiguration;
  zoom: number;
  showViewportStatus?: boolean;
}

export function CanvasStatusOverlay({
  loadState,
  mode,
  zoom,
  showViewportStatus = true,
}: CanvasStatusOverlayProps) {
  const messages = useCanvasMessages();
  return (
    <>
      {showViewportStatus && <div
        aria-live="polite"
        style={{
          position: "absolute",
          right: 12,
          bottom: 12,
          zIndex: 10,
          padding: "6px 10px",
          border: "1px solid #dbe3ee",
          borderRadius: 8,
          color: "#475569",
          background: "rgba(255,255,255,.92)",
          font: "12px/1.3 system-ui, sans-serif",
          pointerEvents: "none",
        }}
      >
        {Math.round(zoom * 100)}% · {messages.modes[mode.mode]}
      </div>}
      {loadState.status !== "ready" && loadState.status !== "empty" && (
        <div
          role={loadState.status === "error" ? "alert" : "status"}
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 30,
            display: "grid",
            placeItems: "center",
            padding: 24,
            background: "rgba(248,250,252,.86)",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <p>
              {loadState.message ??
                (loadState.status === "loading"
                  ? messages.loadingCanvas
                  : messages.failedCanvas)}
            </p>
            {loadState.status === "error" && loadState.retry !== undefined && (
              <button
                type="button"
                onClick={loadState.retry}
                style={{
                  minHeight: 44,
                  padding: "0 18px",
                  border: 0,
                  borderRadius: 8,
                  color: "#ffffff",
                  background: "#4f46e5",
                }}
              >
                {messages.retry}
              </button>
            )}
          </div>
        </div>
      )}
      {loadState.status === "empty" && (
        <p
          aria-live="polite"
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            margin: 0,
            color: "#64748b",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
          }}
        >
          {loadState.message ?? messages.emptyCanvas}
        </p>
      )}
    </>
  );
}
